export default {
    0: 'À la réception',
    15: '15 jours',
    30: '30 jours',
    60: '60 jours',
    90: '90 jours'
};
